<h1 mat-dialog-title>{{ title }}</h1>
<div mat-dialog-content>
    <p>{{ text }}</p>
    <mat-form-field>
        <mat-label>Kategorie</mat-label>
        <mat-select [(value)]="selectedCategory">
            <mat-option *ngFor="let category of categories" [value]="category">
                {{ category }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()">Abbrechen</button>
    <button mat-flat-button color="accent" (click)="dialogRef.close(selectedCategory)" [disabled]="!selectedCategory">
        {{ buttonText }}
    </button>
</div>
